module.exports = __webpack_public_path__ + "static/ec-cube-e7b10bc3ccb0f16c971a71b05c983a10.png";